var path = 'app/portainer/components/slider/slider.html';
var html = "<div>\n  <rzslider rz-slider-options=\"$ctrl.options\" rz-slider-model=\"$ctrl.model\"></rzslider>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;